module.exports = __webpack_public_path__ + "img/openBox-yellow.baf1a396.png";